import React, { useEffect, useState , useContext} from "react";
import { Link} from "react-router-dom";
import { Spinner } from "react-bootstrap";
import $ from 'jquery';
import { useParams } from "react-router-dom";
import ReactGA from "react-ga4";
import UrlHouse from "../../utils/UrlHouse";
import DefaultProfile from '../../asset/default_profile.png';
import VerifiedBadge from '../../asset/verified_badge.png';
import { AppContext } from "../../utils/AppContext";
import { UserData } from "../../utils/UserData";
import Logo from '../../asset/logo_long_transparent_cropped.png';

import "../../spinner.css";

import { useNavigate } from "react-router-dom";

import { Row, Col, Form, Button, Card } from 'react-bootstrap';

import DecorationImage from '../../asset/login_decoration.jpg';

import {Helmet} from "react-helmet";

const VerifyingEmailPage = () => {
    const appContext = useContext(AppContext);
    const [isLoaded, setIsLoaded] = useState(false);
    const navigate = useNavigate();

    const desktopStyles = {
        mainContainerStyle: {
            width: "100%",
            display: "flex",
            textAlign: "center",
            padding: "30px",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: "column",
        },
    }

    const mobileStyles = {
        mainContainerStyle: {
            width: "100%",
            padding: "30px",
        }
    }

    const styles = appContext.mobileMode ? mobileStyles : desktopStyles

    useEffect(() => {
      //$('body').css('background-color','#2E80EB');
      init();
    }, [])

    const init = () => {
        setIsLoaded(false);
        $.ajax({
            type: "POST",
            url: UrlHouse.VERIFY_EMAIL,
            data: JSON.stringify({
                email: params.email, verify_token: params.verify_token
            }),
            dataType: "json",
            success: function (response) {
                if(response.result === 1){
                    setIsLoaded(true);
                }else{
                    navigate('/login');
                }
            },
            error: function(e){
                navigate('/login');
            }
        });
    }

    const params = useParams();
    const [linkPreview, setLinkPreview] = useState({
        title: "Woilo - Photo, Video, Chat, NFTs",
        description: "Woilo - Photo, Video, Chat, NFTs",
        url: "",
        imageUrl: ""
    })

    return(
        <>
            <div style={styles.outerContainerStyle}>
                <Helmet>
                    <title>{linkPreview.title}</title>

                    <meta property="og:title" content={linkPreview.title} />
                    <meta property="og:description" content={linkPreview.description} />
                    <meta property="og:image" content={linkPreview.imageUrl} />
                    <meta property="og:url" content={linkPreview.url} />
                    <meta property="og:type" content="website"/>

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:domain" content="woilo.com" />
                    <meta property="twitter:url" content={linkPreview.url} />
                    <meta name="twitter:title" content={linkPreview.title} />
                    <meta name="twitter:description" content={linkPreview.description} />
                    <meta name="twitter:image" content={linkPreview.imageUrl} />
                </Helmet>
                {
                    isLoaded?
                    <div style={styles.mainContainerStyle}>
                        <h2>Email Telah Terverifikasi</h2>
                        <label>Mulai atur Akun Iklan kamu</label>
                        <Form>
                            <Form.Group as={Row} className="mb-3" style={{marginTop: "10px"}}>
                                <Col sm={{ span: 12}}>
                                    <Button onClick={()=>{navigate('/login')}} style={styles.sendButtonStyle}>
                                        Masuk ke Akun Iklan
                                    </Button>
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    :
                    <></>
                    
                }
            </div>
        </>
    )
}

export default VerifyingEmailPage;